<section class="breadcrumb-banner">
    <div class="container">
        <div class="row">
            <div class="col-md-12 col-lg-12">
                <div class="breadcrumb-text">
                    <h1>2<sup>nd</sup> G.H. Raisoni Memorial Pune International FIDE Rating Open
                        Chess Tournament </h1>
                </div>
            </div>
        </div>
    </div>
    <div class="breadcrumb-bottom-img">
        <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm fide-chess2021 section-banner-bg-1">
    <div class="container">
        <div class="title-heading inner-heading text-center mb-5 shadow-text-sm">
            <h2>2<sup>nd</sup> G.H. Raisoni Memorial Pune International FIDE Rating Open
                Chess Tournament

            </h2>

        </div>
        <div class="row">
            <div class="col-md-12 up-event-text">
                <h5>Event Overview:</h5>
                <p>The 2nd G.H. Raisoni Memorial Pune FIDE Rapid Rating Chess Tournament 2024 was
                    successfully organized by the G.H. Raisoni Sports and Cultural Foundation and the
                    Kalpana Prakash Welfare Foundation. The event received recognition from the Pune
                    District Chess Circle, Maharashtra Chess Association, AICF, and FIDE.</p>
                <h5> Inauguration:</h5>
                <p> The tournament was inaugurated by Chief Guest Shri Ashwin Trimal, Vice President of
                    PDCC &amp; Hon. Secretary of CREDAI Pune Metro, and presided over by Dr. N.B. Hulle,
                    Deputy Director of G.H. Raisoni Institute of Engineering and Management, Pune. Other
                    notable attendees included Shri Bhushan Shriwas, Organizing Secretary &amp; Secretary of
                    Kalpana Prakash Welfare Foundation, Shri S.S. Soman, Member of the MCA Observer
                    Committee, and IA Ajinkya Pingale, Chief Arbiter.</p>
                <h5>Event Highlights:</h5>
                <h5> Participants: 345</h5>
                <h5>Notable Competitors:</h5>
                <p>2 International Masters, 5 FIDE Masters, 3 Candidate Masters,
                    and 1 Woman Candidate Master</p>
                <p><strong>International Participation:</strong> Competitors from the USA and Sweden</p>
                <p><strong> Champion:</strong> FIDE Master Vedant Panesar of Maharashtra emerged victorious, scoring
                    8½ points out of nine rounds and securing the title with an impressive win against IM
                    Abhishek Kelkar of Pune in the final round.</p>
                <h5> Top Performers:</h5>
                <ul>
                    <li> FM Vedant Panesar (Maharashtra) - 8½ points</li>
                    <li> FM Nikhil Dixit (Maharashtra) - 8 points</li>
                    <li>Bharat Kumar Reddy Poluri (Telangana) - 8 points</li>
                </ul>
                <h5> Other Notable Performers:</h5>
                <ul>
                    <li> FM Aniruddha Potawad</li>
                    <li> FM Vedant Nagarkatte</li>
                    <li> Prathamesh Sherla</li>
                    <li> Paras Dilip Bhoir
                </ul>
                <p>Each of these players scored 7½ points and were placed 4th to 7th based on tie-break
                    scores.</p>

                <h5> Prize Distribution:</h5>
                <p>The prize distribution ceremony was graced by Chief Guest Shri Prakash Kunte, Vice
                    President of the Pune District Chess Circle &amp; Trustee of Buddhibal Krida Trust, and
                    Guest of Honour WIM Mrunalini Kunte Aurangabadkar, a former National Women Chess
                    Champion. The ceremony was presided over by Dr. N.B. Hulle. Organizing Secretary
                    Bhushan Shriwas and Chief Arbiter IA Ajinkya Pingale were also present. Shri S.S.
                    Soman conducted the proceedings, read out the winners&#39; names, and proposed the vote
                    of thanks.</p>
                <h5> Cash Prizes:</h5>
                <ul>
                    <li> 1st Place: FM Vedant Panesar - ₹51,000</li>
                    <li> 2nd Place: FM Nikhil Dixit - ₹30,000</li>
                    <li> 3rd Place: Bharat Kumar Reddy Poluri - ₹26,000</li>
                </ul>
                <h5>Special Prizes:</h5>
                <p> Cash prizes were awarded to the top 15 winners, as well as the Best Veteran, Best
                    Woman, Best Pune Player, Best Unrated Player, and the Best Player in various rating
                    categories. Trophies and medals were also distributed to the top players in the Under-7,
                    Under-9, Under-11, Under-13, and Under-15 categories for both boys and girls.</p>
                <h5> Arbiters Team:</h5>
                <p> The event was officiated by Chief Arbiter IA Ajinkya Pingale, assisted by Dy. Chief
                    Arbiter IA Juily Kulkarni, FA Shraddha Vichvekar, FA Amit Tembhurne, FA Amrish Tallu,
                    FA Yashwant Pawar, FA Saumil Shinde, SNA Sagar Sakhare, SNA Prayas Ambade, SNA
                    Purti Tendulkar, Shubham Soni, Ganesh Antad, and Vasanti Sarvade.</p>
            </div>

        </div>
        <div class="gall-ery">
            <div class="row">
                <div class="col-md-8">
                    <div class="widget_title inner-title gall-sys shadow-text-sm">
                        <h4 class="fw-bold">Photos</h4>
                    </div>
                </div>

            </div>
            <div class="lightBox--gallery">
                <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/second-fade-rating-chess-tournament-1.avif"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/second-fade-rating-chess-tournament-1.avif">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/second-fade-rating-chess-tournament-1.avif"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                            </div>
                        </a>
                    </li>

                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/second-fade-rating-chess-tournament-2.avif"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/second-fade-rating-chess-tournament-2.avif">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/second-fade-rating-chess-tournament-2.avif"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                            </div>
                        </a>
                    </li>
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/second-fade-rating-chess-tournament-3.avif"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/second-fade-rating-chess-tournament-3.avif">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/second-fade-rating-chess-tournament-3.avif"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                            </div>
                        </a>
                    </li>
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/second-fade-rating-chess-tournament-4.avif"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/second-fade-rating-chess-tournament-4.avif">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/second-fade-rating-chess-tournament-4.avif"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                            </div>
                        </a>
                    </li>

                </ul>
            </div>
        </div>
    </div>
</section>
